import { createFeatureSelector, createSelector } from '@ngrx/store';
import { includes, reject } from 'lodash';

import { PolicyRouterSelectors } from '@lockton-apps/shared/data-access/router';
import { PolicyStatus } from '@lockton-apps/shared/interfaces';

import {
  POLICIES_FEATURE_KEY,
  policiesAdapter,
  PoliciesState,
} from './policies.reducer';

// Lookup the 'Policies' feature state managed by NgRx
export const selectPoliciesState =
  createFeatureSelector<PoliciesState>(POLICIES_FEATURE_KEY);

const { selectAll: _selectAll, selectEntities: _selectEntities } =
  policiesAdapter.getSelectors();

export const selectLoaded = createSelector(
  selectPoliciesState,
  (state: PoliciesState) => state.loaded
);

export const selectUpdating = createSelector(
  selectPoliciesState,
  (state: PoliciesState) => state.updating
);

export const selectError = createSelector(
  selectPoliciesState,
  (state: PoliciesState) => state.error
);

export const selectAll = createSelector(
  selectPoliciesState,
  (state: PoliciesState) =>
    reject(_selectAll(state), (policy) =>
      includes([PolicyStatus.Defunct, PolicyStatus.Initialized], policy.status)
    )
);

export const selectAllNotDeleted = createSelector(selectAll, (policies) =>
  reject(policies, (policy) => policy.isDeleted)
);

export const selectEntities = createSelector(
  selectPoliciesState,
  (state: PoliciesState) => _selectEntities(state)
);

export const selectSelectedId = createSelector(
  selectPoliciesState,
  (state: PoliciesState) => state.selectedId
);

export const selectSelected = createSelector(
  selectEntities,
  selectSelectedId,
  (entities, selectedId) => (selectedId ? entities[selectedId] : undefined)
);

export const selectRoutedPolicy = createSelector(
  selectEntities,
  PolicyRouterSelectors.selectRoutedId,
  (entities, routedId) => (routedId ? entities[routedId] : undefined)
);
